import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';

//core components
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import useAuth from "hooks/useAuth"
import api from "assets/services/api";
import DatePicker from "components/Datepicker/Datepicker";

//bootstrap imports
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

//material compenents
import AddAlert from "@material-ui/icons/AddAlert";



function ModalUpdateOrderHelp(props) {
    console.log(props.props)
    const [br, setBR] = useState(false);
    const [amount, setAmount] = useState(props.props.name.includes('PECA') ? props.props.weight : props.props.amount );
    const [price_of_product, setPrice_of_product] = useState(props.props.price_of_product);
    const [discount, setDiscount] = useState(props.props.discount);
    const [observation, setObservation] = useState(props.props.observation);
    const [payment_method, setPayment_method] = useState(props.props.payment_method);
    const [batch, setBatch] = useState(props.props.batch);
    const [clientId, setClientId] = useState(props.props.id_client);
    const [date_of_delivery, setDate_of_delivery] = useState(new Date(props.props.date_of_delivery));
    const [productId, setProductId] = useState(props.props.id_product);

    const [products, setProducts] = useState([]);
    const [clients, setClients] = useState([]);

    const { storageId, garlicType } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);


    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    async function handleEditOrder(e) {
        e.preventDefault();
        const response = await api.put('/order/' + props.props.id, {
            amount,
            discount,
            observation,
            payment_method,
            price_of_product,
            batch,
            id_client: clientId,
            id_product: productId,
            date_of_delivery,
            id_admin: storageId
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        setControlSnack(true);
        props.loadOrder();
        props.onHide();
    }

    async function loadProducts() {
        if (garlicType === true) {
            const response = await api.get('/product/admin/garlic/' + storageId);
            setProducts(response.data);
        } else {
            const response = await api.get('/product/admin/' + storageId);
            setProducts(response.data);
        }
    }
    async function loadClients() {
        const response = await api.get('/client/sell/' + storageId);
        setClients(response.data);
    }


    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    useEffect(() => {
        loadProducts();
        loadClients();
    }, [])

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar pedido
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleEditOrder}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridProduct">
                            <Form.Label>Produtos</Form.Label>
                            <Form.Control onChange={event => setProductId(event.target.value)} value={productId} as="select" defaultValue="Choose...">
                                {products.map(product => (
                                    <option key={product.id} value={product.id}>{product.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridClient">
                            <Form.Label>Cliente</Form.Label>
                            <Form.Control onChange={event => setClientId(event.target.value)} value={clientId} as="select" defaultValue="Choose...">
                                {clients.map(client => (
                                    <option key={client.id} value={client.id}>{client.social_reason}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAmount">
                            <Form.Label>Quantidade</Form.Label>
                            <Form.Control onChange={event => setAmount(event.target.value)} value={amount} type="double" placeholder="Quantidade do produto" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPriceOfProduct">
                            <Form.Label>Preço praticado</Form.Label>
                            <Form.Control onChange={event => setPrice_of_product(event.target.value)} value={price_of_product} type="double" placeholder="Preço de venda do produto" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridDiscount">
                            <Form.Label>Desconto</Form.Label>
                            <Form.Control onChange={event => setDiscount(event.target.value)} value={discount} type="double" placeholder="Caso tenha desconto" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridObservation">
                            <Form.Label>Observação</Form.Label>
                            <Form.Control onChange={event => setObservation(event.target.value)} value={observation} type="text" placeholder="Observação do pedido" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridDate">
                            <Form.Label>Data de entrega</Form.Label>
                            <div>
                                <DatePicker
                                    selected={date_of_delivery}
                                    onChange={date => setDate_of_delivery(date.withoutTime())}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Digite ou clique aqui"
                                    disabledKeyboardNavigation />
                            </div>
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Editar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Pedido editado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateOrderHelp;